/** What a code field holds after an edit: the digits of what was typed, pasted
 * or autofilled, in the order they appear, cut to `length`. `complete` is true
 * when this edit is the one that left the code with all `length` digits, so
 * an edit that changes nothing never completes it twice. */
export type OtpChange = { value: string; complete: boolean };

export function normalizeOtp(raw: string, length: number): string {
  return raw.replace(/\D/g, "").slice(0, length);
}

export function otpChange(
  previous: string,
  raw: string,
  length: number,
): OtpChange {
  const value = normalizeOtp(raw, length);
  return { value, complete: value.length === length && value !== previous };
}

const TEXT_ENTRY_TAGS: ReadonlySet<string> = new Set([
  "input",
  "textarea",
  "select",
]);

/** Whether a code field that has just become usable may take focus. It may
 * not while the visitor is typing in another field on the screen, which a
 * code arriving or a send ending must not interrupt. */
export function mayTakeFocus(
  active: { tag: string; isSelf: boolean } | null,
): boolean {
  if (active === null || active.isSelf) return true;
  return !TEXT_ENTRY_TAGS.has(active.tag.toLowerCase());
}
